import React from "react";

export default function RawDataTab({ candidate, application }) {
  return (
    <div className="space-y-6">
      {/* User Raw Data */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">User Raw Data</h3>
        <pre className="text-sm text-white whitespace-pre-wrap bg-gray-700 p-4 rounded-lg overflow-x-auto">
          {JSON.stringify(candidate, null, 2)}
        </pre>
      </div>

      {/* Application Raw Data */}
      {application && (
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Application Raw Data</h3>
          <pre className="text-sm text-white whitespace-pre-wrap bg-gray-700 p-4 rounded-lg overflow-x-auto">
            {JSON.stringify(application, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

